import React from "react";
import OrdersTable from "src/pages/orders";

export default function OrdersPage() {
  return <OrdersTable />;
}